export const TRANSLATE_KEY = {
  transaction: 'transaction',
  addressGroup: 'address_group',
  report: 'report',
  addressList: 'address_list',
  noDbData: 'no_db_data',
  noSearchResult: 'no_search_result',
  search: 'search',
};
